<mat-sidenav-container>
  <mat-sidenav #sidenav mode="side" class="nav-container"
               fixedInViewport="true">
    <div class="d-flex flex-column h-100">
      <div class="d-flex flex-row mt-2">
        <img src="../../../../assets/images/100neediest.png" routerLink="/" class="header-image ml-auto" alt="United Way"/>
        <button mat-icon-button class="ml-auto" (click)="toggleSideNav()"><mat-icon>first_page</mat-icon></button>
      </div>

      <mat-accordion class="mt-4 nav-menu" multi>
        <mat-expansion-panel [expanded]="i === 0" *ngFor="let item of sideNavItems$ | async; let i = index;" class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="mr-2">{{item.icon}}</mat-icon>
              {{item.title}}
            </mat-panel-title>
          </mat-expansion-panel-header>
           <div class="row w-100 no-gutters pl-3" *ngFor="let navItem of item.children">
             <button mat-button class="w-100 text-left nav-menu-item" [routerLink]="navItem.route">
               {{navItem.title}}
             </button>
           </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="d-flex mt-auto py-2 align-content-center">
        <img src="../../../../assets/images/uw-logo-short.png" class="logo-image mx-auto" alt="United Way"/>
      </div>

    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-header (expandSideMenuClick)="toggleSideNav()" [sideNavVisible]="(sideNavState$ | async) === 'open'"></app-header>
    <div class="set-height scroll-vert">
    <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
